import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Landing page debug controller connected")

    const form = this.element
    console.log("Form element:", form)
    console.log("Form action:", form.action)
    console.log("Form method:", form.method)

    form.addEventListener('submit', (event) => {
      console.log("Form submit event fired!")
      console.log("Event:", event)
      console.log("Form is submitting to:", form.action)
    })
  }
}
